import { apiGet } from '../../api/api-configuration';
import {
  API_ARTICLES_ENDPOINT,
  API_COMPLETE_ARTICLES,
  HERO,
  SUB_HERO,
  TRENDING_ARTICLE_COUNT,
  LATEST_ARTICLE_COUNT,
  API_MARKET_COMPARISON_ENDPOINT,
  API_INITIATE_MARKET_COMPARISON,
  API_COMPLETE_MARKET_COMPARISON,
  API_INITIATE_PRODUCT_RECOMMENDATION,
  API_COMPLETE_PRODUCT_RECOMMENDATION,
  API_PRODUCT_RECOMMENDATION_ENDPOINT,
  UPDATE_ALL_PRODUCT_RECOMMENDATION,
  BUSINESS_CASE_BUILDER_SELECT_ALL,
  API_UPDATE_PRODUCT_RECOMMENDATION,
  RESET_PRODUCT_RECOMMENDATIONS,
} from '../../app-constants';
import { trimArray, failureAction } from '../../app-actions';


// Actions

// getArticles
export const processArticles = (articles) => {
  const { trendingArticles = [], latestArticles = [] } = articles.data || {};
  // trim trendingArticles displayed to the pre-defined value
  const trendingArticlesTrimmed = trimArray(trendingArticles, TRENDING_ARTICLE_COUNT);
  trendingArticlesTrimmed.forEach((article, index) => {
    if (index === 0) {
      trendingArticlesTrimmed[index].layoutMode = HERO;
    } else if (index < 3) {
      trendingArticlesTrimmed[index].layoutMode = SUB_HERO;
    }
  });
  // trim latestArticles displayed to the pre-defined value
  const latestArticlesTrimmed = trimArray(latestArticles, LATEST_ARTICLE_COUNT);
  return { ...articles, trendingArticles: trendingArticlesTrimmed, latestArticles: latestArticlesTrimmed };
};

export const successAction = (articlesData) => {
  const processedArticles = processArticles(articlesData);
  return { type: API_COMPLETE_ARTICLES, data: processedArticles };
};

export const getArticles = data => (dispatch) => {
  const endpoint = API_ARTICLES_ENDPOINT;
  apiGet(dispatch, endpoint, successAction, failureAction, data);
};

// market comparison - for graphs
export const processMarketComparison = (data) => {
  const { avgCustomerScore, avgMarketScore } = data;
  return [avgCustomerScore, avgMarketScore];
};

export const successActionMarketComparison = (response) => {
  const { data } = response;
  const processedMarketComparison = processMarketComparison(data);
  return { type: API_COMPLETE_MARKET_COMPARISON, data: processedMarketComparison };
};

export const getMarketComparison = data => (dispatch) => {
  const endpoint = API_MARKET_COMPARISON_ENDPOINT;
  dispatch({ type: API_INITIATE_MARKET_COMPARISON });
  apiGet(dispatch, endpoint, successActionMarketComparison, failureAction, data);
};

// recommendations
export const processProductRecommendation = (data) => {
  const { productRecommendationList } = data;
  return productRecommendationList;
};

export const successActionProductRecommendation = (response) => {
  const { data } = response;
  const processedProductRecommendation = processProductRecommendation(data);
  return { type: API_COMPLETE_PRODUCT_RECOMMENDATION, data: processedProductRecommendation };
};

export const getProductRecommendation = data => (dispatch) => {
  const endpoint = API_PRODUCT_RECOMMENDATION_ENDPOINT;
  dispatch({ type: API_INITIATE_PRODUCT_RECOMMENDATION });
  apiGet(dispatch, endpoint, successActionProductRecommendation, failureAction, data);
};

export const resetProductRecommendations = () => ({ type: RESET_PRODUCT_RECOMMENDATIONS });

// update & save product recommendations
export const successActionUpdateProductRecommendation = (response) => {
  const { data } = response;
  return { type: API_UPDATE_PRODUCT_RECOMMENDATION, data };
};

export const prepareProductRecommendationPayload = (data) => {
  const { checkBoxState, productRecommendation } = data;
  const { id, checked } = checkBoxState;
  /* for selectAll send all - products states - as payload  */
  const dataForPayload = (id === BUSINESS_CASE_BUILDER_SELECT_ALL) ?
    productRecommendation : [checkBoxState];

  const payloadData = dataForPayload.map(element => ({
    recommendedProductCode: element.id || element.recommendedProductCode,
    recommendationSelected: element.checked || checked,
  }));
  return { productRecommendationList: payloadData };
};

export const updateAllProductRecommendation = productData => (dispatch) => {
  const { checkBoxState, viewAll } = productData;
  dispatch({ type: UPDATE_ALL_PRODUCT_RECOMMENDATION, checkBoxState, viewAll });
};

